import styled, { css, keyframes } from 'styled-components'

import { bordergray, white, black, red, almostblack } from '../../styles/colors'
import { maxmedia, minmedia } from '../../styles/media-queries'

function animation(props) {
  return keyframes`
    0% {
      opacity: 0;
    };
    15% {
      opacity: 1;
    };
    85% {
      opacity: 1;
    };
    100% {
      opacity: 0;
    };
  `
}

export const Notes = styled.div`
  width: 100%;
  border: 1px solid ${bordergray};
  padding: 1rem 2rem;
  background: ${white};
  ul {
    list-style: disc inside;
  }
`

export const Results = styled.div`
  width: 100%;
  min-height: 1rem;
  max-height: 15rem;
  overflow-y: scroll;
  background: ${white};
  top: 0;
  left: 0;
  transform: translateY(48px);
  position: absolute;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border: 1px solid ${bordergray};
  border-top: 0;
  z-index: 10;
`

export const Header = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  text-align: left;
  font-size: 20px;
  padding: 0 1.5rem;

  ${minmedia.large`
    font-size: 24px;
    padding: 0; //reset
  `};
`

export const ProductContainer = styled.div`
  width: 100%;

  ${minmedia.xmlarge`
    width: calc(70% - 1rem);
  `};
`

export const OrderContainer = styled.div`
  width: 100%;
  order: -1;
  ${minmedia.xmlarge`
    align-self: baseline;
    width: calc(30% - 1rem);
    order: 2;

    border-radius: 0.25rem;
    background: ${white};
    margin-top: 79px;
  `};
`
export const DesktopWrapper = styled.div`
  ${maxmedia.xmlarge`
    display: none;
  `};
`

export const MobileWrapper = styled.div`
  width: 100%;
  ${minmedia.xmlarge`
    display: none;
  `};
`

export const Wrapper = styled.div`
  padding: 0 1.5rem;
  z-index: 5;
  position: relative;
  ${minmedia.large`
    padding: 0;
    padding-bottom: 1.5rem;
  `} ${minmedia.xmlarge`
    padding: 2rem 1.5rem;
        border: 1px solid ${bordergray};
  `} ${props =>
      props.firstChild &&
      css`
        border-bottom: 1px solid ${bordergray};

        ${maxmedia.xmlarge`
      padding-bottom: 1.5rem;
      margin-bottom: 1.5rem;
    `};
      `};

  ${props =>
    props.secondChild &&
    css`
      ${maxmedia.xmlarge`
      display: none;
    `};
    `};
`

export const Title = styled.header`
  font-size: 20px;
  margin-bottom: 1rem;

  ${minmedia.xmlarge`
    font-size: 24px;
    font-weight: 300;
    margin-bottom: 1.5rem;
  `};
`

export const InputContainer = styled.div`
  width: 100%;
  position: relative;

  input {
    background-color: ${white};
  }
`

export const Amount = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 300;
  max-width: 300px;
  width: 100%;
`

export const Price = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 300;
  max-width: 300px;
  margin-top: 1rem;
  width: 100%;
`

export const Button = styled.div`
  transition: all 0.5s;
  cursor: pointer;
  position: relative;
  width: 100%;
  padding: 1rem;
  border-radius: 0.25rem;
  margin-top: 2rem;
  display: inline-block;
  background: ${red};
  color: ${white};
  text-align: center;
  font-size: 20px;
  font-weight: 300;
  a {
    color: ${white};
    text-decoration: none;
  }
  &:hover {
    background: ${almostblack};
  }
`

// MOBILE ONLY

export const StickyOrder = styled.div`
  // position: fixed;
  // bottom: 57px; //above bottombar
  // left: 0;
  width: 100%;
  background: ${white};
  border-bottom: 1px solid ${bordergray};
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  // padding: .75rem 1.25rem;
  padding: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  ${minmedia.large`
    border-left: 1px solid ${bordergray};
    border-right: 1px solid ${bordergray};
  `} ${minmedia.xmlarge`
    display: none;
  `};
`

export const StickyAmount = styled.div`
  font-size: 18px;
  font-weight: 300;
  padding: 0.5rem 0; //if they have no 'order' button

  strong {
    margin-left: 0.25rem;
  }
`

export const StickyPrice = styled.div`
  font-size: 18px;
  font-weight: 300;
  margin-top: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.5rem 0; //if they have no 'order' button

  strong {
    margin-left: 0.25rem;
  }
`

export const StickyButton = styled.div`
  transition: all 0.5s;
  cursor: pointer;
  padding: 0.75rem 1.25rem;
  border-radius: 0.25rem;
  display: inline-block;
  background: ${red};
  color: ${white};
  font-size: 18px;
  font-weight: 300;
  a {
    color: ${white};
    text-decoration: none;
  }
  ${minmedia.medium`
    padding: 1rem 2rem;
  `} &:hover {
    background: ${almostblack};
  }
`

export const ProductPopup = styled.div`
  width: 400px;
  max-width: 97%;
  height: auto;
  background: ${black};
  opacity: 0.7;
  color: ${white};
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2rem;
  z-index: 100;
  line-height: 1.5;
  padding: 1rem 4.25rem;
  border-radius: 0.25rem;
  text-align: center;
  animation: ${props => `${animation(props)} 4s 1`};
  animation-direction: normal;
  animation-fill-mode: forwards;
  svg {
    width: 2.25rem;
    height: 2.25rem;
    fill: ${white};
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }
`

export const ProductHeader = styled.div`
  padding: 2rem 0 1rem;
  border-bottom: 1px solid ${bordergray};
  border-top: 0;
  ${maxmedia.medium`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    a {
      font-size: 14px;
      padding-right: 1rem;
    }
    h3 {
      margin-bottom: 0;
    }
  `};
  ${minmedia.large`
    border-top: 0;
    border-bottom: 1px solid ${bordergray};
  `};
`

export const ProductTitle = styled.h3`
  display: inline;
  padding-right: 1.25rem;
  ${maxmedia.large`
    padding: 0 1rem;
  `};
`

export const Content = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  width: 100%;
  border-top: 1px solid ${bordergray};
  h4 {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 0.5rem;
  }
  p {
    margin-bottom: 0;
  }
  span {
    margin-bottom: 1rem;
    font-size: 16px;
    display: block;
    font-style: italic;
  }
  ${props => props.mobile && css`
    padding: 1rem 1.25rem;
    margin-top: 0;
    border-top: 0;
    border-bottom: 1px solid ${bordergray};
    z-index: 3;
    h4 {
      font-size: 16px;
    }
    span {
      font-size: 14px;
    }
    input {
      background: ${white};
    }
    ${minmedia.xmlarge`
      display: none;
    `};
  `};
`

export const Seperator = styled.div`
  padding: 2rem 0;
  margin-top: 3rem;
  font-size: 1.75rem;
  font-weight: 600;
  font-family: 'Trocchi', sans-serif;
  border-top: 2px dashed ${bordergray};
  border-bottom: 2px dashed ${bordergray};
  ${maxmedia.medium`
    font-size: 1.25rem;
    padding: 1rem 1rem;
    margin-top: 2rem;
  `};
`


// WEBPACK FOOTER //
// ./src/components/Orders/styles.js